import * as React from 'react';

import type { TFieldProps } from 'client/components/common/BuildingBlocks/Fields/types';

interface Props extends TFieldProps {
	inputRef: React.RefObject<HTMLInputElement>;
}

export const WordModeInput = (props: Props) => {
	const { inputRef, ...inputProps } = props;

	return <input {...inputProps} maxLength={100} ref={inputRef} />;
};
